define('responsive-game-feed/app/scripts/utils/HotColdUtils',[],function(){

// PRIVATE VARS
	// object associating zone color names with css class names
	var HOTZONE_COLOR_CLASSES = {hot:"hotColdZoneDisplay_hot", warm:"hotColdZoneDisplay_warm", neutral:"hotColdZoneDisplay_neutral", cool:"hotColdZoneDisplay_cool", cold:"hotColdZoneDisplay_cold", nodata:"hotColdZoneDisplay_neutral"};
	var HotColdUtils = {
		
		/**
		 * function ggetHotZoneTemp
		 * @param sweetness : Number
		 * @param b_or_p : String "b" or "p"
		 * @param capitalized : boolean
		 * @descrip returns named string based on number value of 'sweetness'
		 * 
		 */
		getHotZoneTemp : function(sweetness, b_or_p, capitalized) {
			var temp;
		
			if(sweetness >= 1.15) {
				temp = (b_or_p == "b") ? "Hot" : "Cold";
			} else if (sweetness >= 1.05) {
				temp = (b_or_p == "b") ? "Warm" : "Cool";
			} else if (sweetness >= 0.95) {
				temp = "Neutral";
			} else if (sweetness >= 0.85) {
				temp = (b_or_p == "b") ? "Cool" : "Warm";
			} else if (sweetness < 0.85) {
				temp = (b_or_p == "b") ? "Cold" : "Hot";
			} else {
				temp = (capitalized) ? "No Data" : "nodata";
			}
			
			return (capitalized) ? temp : temp.toLowerCase();
		},
		
		/**
		 * function ggetHotZoneTemp
		 * @param sweetness : Number
		 * @param b_or_p : String "b" or "p"
		 * @descrip returns css class associated with a particular hot cold sweetness
		 */
		getHotZoneColorClass : function(sweetness, b_or_p) {
			var temp = this.getHotZoneTemp(sweetness, b_or_p, false);
			return HOTZONE_COLOR_CLASSES[temp];
		}
	}

	return HotColdUtils; 
    
});
